import type { IconProps } from './types';

export function Biquini({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M40 124 Q56 64 116 60 Q122 56 124 60 Q124 92 124 124 Q82 128 40 124 Z" />
      <path d="M216 124 Q200 64 140 60 Q134 56 132 60 Q132 92 132 124 Q174 128 216 124 Z" />
      <path d="M116 60 Q88 40 64 32" />
      <path d="M140 60 Q168 40 192 32" />
      <circle cx="128" cy="132" r="6" />
      <path d="M72 164 Q128 160 184 164 Q160 196 132 224 Q126 226 124 224 Q96 196 72 164 Z" />
      <path d="M72 164 Q56 180 48 196" />
      <path d="M184 164 Q200 180 208 196" />
    </svg>
  );
}
